<template>
  <select v-model="data" @change="$emit('update:modelValue', data)" :disabled="disabled">
    <option v-for="(option, index) in options" :key="index"
      :value="option.value"
      :selected="option.selected"
      :disabled="option.disabled">
      {{ (option.text !== undefined) ? option.text : option }}
    </option>
  </select>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const data = ref(props.modelValue);

const props = defineProps({
  modelValue: [String, Object, Number],
  options: Array,
  disabled: Boolean
})

</script>